import { render } from "./QuotationComponent.vue?vue&type=template&id=a6474386&scoped=true"
import script from "./QuotationComponent.vue?vue&type=script&lang=js"
export * from "./QuotationComponent.vue?vue&type=script&lang=js"

import "./QuotationComponent.vue?vue&type=style&index=0&id=a6474386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6474386"]])

export default __exports__